import new_germany from '../images/newProductPage/languages/DE.png';
import new_spanish from '../images/newProductPage/languages/ES.png';
import new_french from '../images/newProductPage/languages/FR.png';
import new_italy from '../images/newProductPage/languages/IT.png';
import new_niderland from '../images/newProductPage/languages/ND.png';
import new_polish from '../images/newProductPage/languages/PL.png';
import new_portugal from '../images/newProductPage/languages/PR.png';
import new_russia from '../images/newProductPage/languages/RU.png';
import new_england from '../images/newProductPage/languages/UK.png';

import screen3 from '../images/newProductPage/slovak/1.png';
import screen4 from '../images/newProductPage/slovak/2.png';
import screen5 from '../images/newProductPage/slovak/3.png';
import screen6 from '../images/newProductPage/slovak/4.png';
import screen1 from '../images/newProductPage/slovak/5.png';
import screen2 from '../images/newProductPage/slovak/6.png';

import dlaczego1 from '../images/newProductPage/why/dlaczego_1.webp';
import dlaczego2 from '../images/newProductPage/why/dlaczego_2.webp';
import dlaczego3 from '../images/newProductPage/why/dlaczego_3.webp';

import zdjecie2 from '../images/newProductPage/mission/latop_square.png';
import zdjecie3 from '../images/newProductPage/mission/people_square.png';
import zdjecie1 from '../images/newProductPage/mission/women_square.png';

export const slovenian = {
  navbar: {
    data: [
      { title: 'Naroči tečaj', path: '/course' },
      { title: 'Prijava', path: '/start' },
      { title: 'eLingo', path: '/' },
      { title: 'O nas', path: '/about' },
      { title: 'Mnenja', path: '/reviews' },
    ],
  },
  mainPage: {
    product_page: {
      language: 'sl',
      hero: {
        languages: [
          'v angleščini',
          'v španščini',
          'v nemščini',
          'v nizozemščini',
          'v italijanščini',
          'v ruščini',
          'v poljščini',
          'v francoščini',
          'v portugalščini',
        ],
        title: 'Govorite samozavestneje,',
        prefix: 'z gotovostjo',
        subtitle:
          'Pridobite jezikovne veščine s tečajem, ki temelji na primerih iz resničnega življenja!',
        buttonText: 'Naroči zdaj!',
      },
      learning: {
        title: 'Kako izgleda tečaj?',
        config: [
          {
            image: screen1,
            category: 'Naučite se jezika na najlažji način',
            descriptions: [
              {
                bold: 'Desetine lekcij',
                rest: 's primeri, ki temeljijo na vsakodnevni komunikaciji.',
              },
              {
                bold: 'Praktične fraze',
                rest: 'oblikovane s strani naravnih govorcev.',
              },
              {
                bold: 'Vaje,',
                rest: 'ki učinkovito razvijajo branje, poslušanje in govorjenje.',
              },
            ],
          },
          {
            image: screen2,
            category: 'Praktične lekcije',
            description:
              'Vsaka raven učenja je sestavljena iz desetin lekcij, prilagojenih vašim potrebam.',
          },
          {
            image: screen3,
            category: 'Naloge',
            description:
              'Naše vaje učinkovito podpirajo ponavljanje snovi in izboljšujejo spomin.',
          },
          {
            image: screen4,
            category: 'Besede, fraze in izrazi',
            description:
              'Vsaka lekcija vsebuje skrbno izbrane slike, ki naredijo proces učenja intuitiven.',
          },
        ],
        photoData: [screen1, screen2, screen3, screen4, screen5, screen6],
      },
      languages: {
        languages: [
          { image: new_england, lang: 'Angleščina' },
          { image: new_french, lang: 'Francoščina' },
          { image: new_spanish, lang: 'Španščina' },
          { image: new_niderland, lang: 'Nizozemščina' },
          { image: new_germany, lang: 'Nemščina' },
          { image: new_italy, lang: 'Italijanščina' },
          { image: new_russia, lang: 'Ruščina' },
          { image: new_portugal, lang: 'Portugalščina' },
          { image: new_polish, lang: 'Poljščina' },
        ],
        title: 'Razpoložljivi jeziki:',
        description:
          'Pripravite se na svoje naslednje potovanje ali dodajte jezikovne veščine v svoj življenjepis.',
      },
      expertSection: {
        title: 'Vaš jezikovni strokovnjak',
        firstSectionTitle: 'Podpora na dosegu roke',
        firstSectionDescription: 'Pridobite popolno podporo pri učenju!',
        secondSectionTitle: 'Postavljajte vprašanja in dobite odgovore',
        secondSectionDescription:
          'Kakršna koli vprašanja lahko postavite neposredno svojemu strokovnjaku.',
        thirdSectionTitle: 'Individualni pristop na vsakem koraku',
        thirdSectionDescription:
          'Nasveti jezikovnega strokovnjaka bodo pospešili vaše učenje.',
      },
      courseValue: {
        title: 'Pridobite več z eLingo',
        subtitle: 'Ne le učenje jezikov – pridobite popoln dostop do orodij.',
        buttonText: 'Naroči zdaj!',
        config: [
          {
            title: 'Učenje, prilagojeno vašemu življenjskemu slogu',
            sections: [
              {
                text: 'Učite se, kjer želite in kdaj želite, zahvaljujoč platformi, dostopni na različnih napravah.',
              },
              {
                text: 'Kratke lekcije se popolnoma vklopijo v vaš vsakodnevni urnik.',
              },
            ],
          },
          {
            title: 'Motivacija na vsakem koraku',
            sections: [
              {
                text: 'Ohranjajte svoj niz dni učenja s pomočjo našega sistema sledenja.',
              },
              {
                text: 'Vsak dan učenja je korak bližje jezikovni tekočnosti.',
              },
            ],
          },
          {
            title: 'Popolna fleksibilnost in personalizacija',
            sections: [
              {
                text: 'Prilagodite tečaj svoji ravni in tempu učenja.',
              },
              {
                text: 'Osredotočite se na tisto, kar vas najbolj zanima.',
              },
            ],
          },
        ],
      },
      faq: {
        title: 'Pogosta vprašanja',
        subtitle: 'Imate vprašanja? Mi imamo odgovore.',
        sections: [
          {
            title: 'O eLingu',
            questions: [
              {
                question: 'Kaj je eLingo?',
                answer:
                  'eLingo je spletna platforma za učenje tujih jezikov, ki vam omogoča hitro in učinkovito obvladovanje govorjenja in razumevanja v praksi.',
              },
              {
                question: 'Kako delujejo jezikovni tečaji eLingo?',
                answer:
                  'Po prijavi dobite dostop do interaktivnih spletnih lekcij in gradiv, ki jih lahko opravite kadarkoli vam ustreza. Tečaji so prilagojeni vaši ravni in ciljem.',
              },
              {
                question: 'Ali eLingo resnično pomaga pri učenju govorjenja?',
                answer:
                  'Da. Naši tečaji se osredotočajo na praktično komunikacijo – zahvaljujoč interaktivnim vajam boste hitro premagali strah pred govorjenjem.',
              },
            ],
          },
          {
            title: 'Plačila in dostava',
            questions: [
              {
                question: 'Kako lahko plačam za tečaj eLingo?',
                answer:
                  'Plačate lahko spletno ali ob prevzemu pošiljke od kurirja.',
              },
              {
                question: 'Ali so moji podatki in plačila varni?',
                answer:
                  'Da. Vsi podatki so zaščiteni v skladu z uredbo GDPR, plačila – tako spletna kot ob prevzemu – pa so zavarovana in obdelana pri zanesljivih partnerjih.',
              },
              {
                question: 'Ali je plačilo ob prevzemu varno?',
                answer:
                  'Da. Kurir vam dostavi pošiljko in plačilo opravite varno ob prevzemu.',
              },
              {
                question: 'Kdaj dobim dostop do tečaja po plačilu naročila?',
                answer:
                  'Dostop se samodejno aktivira z vnosom kode na navedeni strani.',
              },
              {
                question: 'Kaj se zgodi, če pošiljke ne prevzamem?',
                answer:
                  'Če pošiljke ne prevzamete, se dostop do tečaja ne aktivira. Tečaj pa lahko naročite znova, ko vam bo ustrezalo.',
              },
            ],
          },
          {
            title: 'Varnost, zaupanje in podpora',
            questions: [
              {
                question: 'Ali so moji osebni podatki v eLingu varni?',
                answer:
                  'Da. Uporabljamo šifriranje in standarde varstva podatkov v skladu z evropsko zakonodajo.',
              },
              {
                question: 'Ali je eLingo zakonito in registrirano podjetje?',
                answer:
                  'Da. eLingo je izobraževalna blagovna znamka podjetja European Learning Agency, ki deluje v skladu z zakonom in je registrirano v Evropski uniji. Podrobne informacije o podjetju in registraciji najdete v pogojih, dostopnih na naši spletni strani.',
              },
              {
                question: 'Kako lahko stopim v stik s podporo eLingo?',
                answer:
                  'Lahko pišete na naslov podpora@elingo-edu.com ali uporabite kontaktni obrazec, dostopen na spletni strani.',
              },
              {
                question:
                  'Ali ponujate garancijo zadovoljstva ali vračilo denarja?',
                answer:
                  'Da. Če tečaj ne izpolni vaših pričakovanj, ponujamo možnost odpovedi ali vračila denarja v skladu s pogoji – brez tveganja.',
              },
            ],
          },
        ],
      },
    },
  },
  aboutUs: {
    hero: {
      title: 'Poslanstvo',
      description: `Verjamemo, da jezik gradi mostove med kulturami, naše poslanstvo pa je premagovanje komunikacijskih ovir in povezovanje ljudi prek jezikovnega izobraževanja.`,
    },
    why: {
      title: 'Zakaj mi?',
      config: [
        {
          title: 'Inovativne učne metode',
          image: dlaczego1,
          description:
            'Naš sofisticiran in v praksi preizkušen učni algoritem prilagaja gradiva vaši trenutni ravni znanja in jo razširja z učinkovitim poučevanjem.',
        },
        {
          title: 'Široka paleta jezikov',
          image: dlaczego2,
          description:
            'Ponujamo tečaje v najpopularnejših jezikih na svetu. To vam omogoča, da izberete jezik glede na vaše potrebe.',
        },
        {
          title: 'Učenje na zabaven način',
          image: dlaczego3,
          description:
            'Naša platforma naredi učenje jezika zabavno in prijetno izkušnjo, tako da boste motivirani za učenje jezikov.',
        },
      ],
    },
    mission: {
      config: [
        {
          title: 'Personalizacija in dostopnost',
          description:
            'Naš učinkovit algoritem strojnega učenja neprestano deluje na zagotavljanju gradiv, primernih za vsakega posameznika. eLingo omogoča učencem, da samostojno odkrivajo vzorce, brez potrebe po osredotočanju na jezikovne pravila – prav tako, kot ste se v otroštvu naučili svojega maternega jezika.',
          image: zdjecie1,
        },
        {
          title: 'Kombinacija tehnologije in znanosti',
          description:
            'eLingo uporablja drzno kombinacijo tehnologije in znanosti za spodbujanje uma k delovanju. Ponavljanje neštetih seznamov besed in fraz je dolgočasno in vaš možgani to vedo. Naša metoda je vznemirljiva in učinkovita, prisili vas, da uporabite pridobljeno znanje na različne načine v konkretnih trenutkih – vaši možgani bodo cenili to rešitev!',
          image: zdjecie2,
        },
        {
          title: 'Skupnost in vrednote',
          description:
            'Jeziki pomagajo ljudem, da se zbližajo. Učenje jezikov olajša razumevanje. Skupnost eLingo povezuje ljudi z vsega sveta. Smo ambiciozni in nenehno prestopamo meje. Verjamemo, da je učenje jezikov lahko zabavno, in z veseljem spoznavamo nove kulture prek jezika.',
          image: zdjecie3,
        },
      ],
    },
  },
  formSender: {
    formControll: {
      pageLink: 'https://nyelvfejlesztesi-kozpont.eu/',
      title: 'Vas zanima tečaj?  ',
      title1: 'Želite izvedeti več informacij?',
      subtitle: 'Pustite svojo telefonsko številko',
      subtitle1: 'Poklicali vas bomo.',
      button1: 'Ime in priimek',
      button2: 'Telefonska številka',
      button3: 'E-pošta',
      buttonSub: 'Pošlji',
      checkOne:
        'Z oddajo tega obrazca se strinjam s pogoji in izjavljam, da sem prebral/a naslednje informacije',
      checkOneTwo: 'the',
      checkTwo: 'Strinjam se s kontaktiranjem v tržne namene',
      textOne: 'Obveščamo vas, da je',
      textTwo:
        'Upravljavec vaših osebnih podatkov je podjetje ELA Sp. z o.o., s sedežem v Varšavi, Młynarska 42 / 115, 01-171, vpisano v register podjetnikov pri okrožnem sodišču v Varšavi pod številko KRS 5273057993, REGON: 525396900, NIP 5273057993. Vaši osebni podatki bodo obdelani v zvezi s poizvedbo prek kontaktnega obrazca ali z izpolnjevanjem sklenjene pogodbe. Z vzpostavitvijo stika z nami prostovoljno soglašate z obdelavo vaših osebnih podatkov za zgoraj navedene namene. Imate pravico do dostopa do svojih podatkov, njihovega popravka, izbrisa ali omejitve obdelave, pravico do ugovora zoper obdelavo in pravico do prenosljivosti podatkov. Prav tako imate pravico kadar koli preklicati soglasje, vendar preklic soglasja ne vpliva na zakonitost obdelave, ki je temeljila na soglasju pred njegovim preklicem. Imate tudi pravico do vložitve pritožbe pri nadzornem organu. Posredovanje podatkov je prostovoljno, vendar je lahko potrebno za odgovor na zahtevo ali za izpolnitev pogodbe. Osebni podatki bodo hranjeni toliko časa, kolikor je potrebno za zgoraj navedene namene, vendar ne dlje, kot je rok zastaranja terjatev po splošnih pravnih predpisih. Pozorno preberite politiko zasebnosti',
      buttonMore: 'Preberi več',
      buttonLess: 'Preberi manj',
      subOne: 'pogoje',
      subTwo: 'in pravila zasebnosti.',
      buttonTXT: 'Hvala',
      rulesLink: '/Regulations_SL_European_Learning_Agency_elingo.pdf',
      privacyLink: '/Privacy_SL_European_Learning_Agency.pdf',
      product: 'esi',
      market: 'si',
      send_to_url: 'https://crm.eou-edu.eu/api/v1/cms/create_order',
      utm_source: 'Platform_eLingo',
      product_variant: 'si-en',
      server_link: 'https://cms.eou-edu.eu/integration/lead-from-landing',
      currency: 'eur',
      price: 117,
    },
  },
  reviews: {
    language: 'sl',
    title: 'Mnenja o eLingu',
    subtitle:
      'Vaša ocena je pomembna – mnenja o eLingu nam pomagajo razvijati platformo v skladu s potrebami uporabnikov.',
    contentPlaceholder: 'Začni pisati',
    submitButton: 'Pošlji',
    thankYouText:
      'Hvala, da delite svoje izkušnje in skupaj z nami ustvarjate učinkovito orodje za učenje jezikov!',
    recommendedLabel: 'Priporočeno',
    items: [
      {
        text: 'Metoda poučevanja je odlična, daleč pred tistim, kar sem srečal na drugih platformah.',
        isRecommended: true,
      },
      {
        text: 'Zahvaljujoč interaktivnim vajam sem hitro napredoval. Z zaupanjem priporočam vsakomur, ki želi resnične rezultate.',
        isRecommended: true,
        isLarge: true,
      },
      {
        text: 'Zelo intuitivna platforma. Navadil sem se je že v prvih minutah brez kakršnekoli pomoči.',
        isRecommended: true,
      },
      {
        text: 'Tehnična podpora je odzivna. Niti sekunde se v tem procesu nisem počutil sam.',
        isRecommended: true,
      },
      {
        text: 'Gradiva so izjemno dobro strukturirana in ponujajo jasen vpogled v proces učenja. Vsaka lekcija logično sledi prejšnji, zato je napredek zelo naraven in intuitiven. Razlage so podrobne, praktični primeri pa izjemno pomagajo pri utrjevanju znanja in spreminjajo učenje v prijetno in dolgoročno učinkovito izkušnjo.',
        isRecommended: true,
        isTall: true,
      },
      {
        text: 'Prilagodljivost je največja prednost. Lahko se učim kadarkoli, kjerkoli, na katerikoli napravi.',
        isRecommended: true,
      },
      {
        text: 'Oblikovanje je prijazno do oči. Lahko se učim ure in ure, ne da bi se utrudil.',
        isRecommended: true,
      },
      {
        text: 'Besedišče sem izboljšal v rekordnem času. Vse je zelo praktično.',
        isRecommended: true,
      },
      {
        text: 'Resnično sodobna učna izkušnja. Pomagala mi je premagati strah pred govorjenjem v tujem jeziku.',
        isRecommended: true,
        isLarge: true,
      },
      {
        text: 'Zvočna kakovost tečajev je brezhibna, kar je bistveno za pravilno razumevanje.',
        isRecommended: true,
      },
      {
        text: 'Sistem igrifikacije te motivira, da se vračaš vsak dan in nenehno napreduješ.',
        isRecommended: true,
      },
      {
        text: 'Neverjetno je, kako vidiš viden napredek iz tedna v teden. Naložba se splača!',
        isRecommended: true,
      },
      {
        text: 'Vmesnik je čist, brez oglasov in elementov, ki bi te odvračali od učenja.',
        isRecommended: true,
      },
      {
        text: 'Skupnost je zelo dejavna in prijazna. Vedno najdeš odgovore na vprašanja.',
        isRecommended: true,
      },
    ],
  },
  footer: {
    title: 'Pridružite se nam na:',
    privacy: 'Varstvo osebnih podatkov',
    privacyLink: '/Privacy_SL_European_Learning_Agency.pdf',
    rules: 'Pogoji storitve',
    rulesLink: '/Regulations_SL_European_Learning_Agency_elingo.pdf',
  },
};
